import { callAuthorizedGraphQLEndpoint } from '../../Module/graphQL'
import { normalizeGraphQLConnection } from '../../shared/graphql/utils'

export default async options => {
  const query = `
          query (
            $campaignId:ID
            $cityId:ID!
            $startDate:String
            $endDate:String
          ){
              city(id: $cityId) {
            missions(
              campaignId: $campaignId
              startDate: $startDate
              endDate: $endDate
              statusAndAbove: BOOKED
            ) {
              edges {
                node {
                  id
                  payOut
                  surgePayout
                  dateTime
                  user {
                    id
                    firstName
                    lastName
                    businessNumber
                  }
                  client {
                    name
                  }
                  cityPlan {
                    payout
                    city {
                        name
                      }
                  }
                }
              }
            }
        }
          }`
  const req = await callAuthorizedGraphQLEndpoint(query, options)
  const { data } = await req.json()
  return normalizeGraphQLConnection(data.city.missions)
}



// WEBPACK FOOTER //
// ./src/Components/ExportRoster/gql.js